/* global _ jQuery */

(function ($) {
	"use strict";

	$(document).ready(function(){

		/**
		 * session tabs
		 * show active tab, animate and reposition the underbar
		 * show/hode the tab content
		*/

		var $item, $active_item, leftPos, newWidth, $session, $session_section;
		var $underline = $(".underbar");

		$underline
		.width($(".active-session").width())
		.css("left", $(".active-session")
		.position().left);

		$(".js-q-session-items").on("click", function() {
			
			$item = $(this);
			$session = $item.data("session");
			$session_section = $(".q-grid__row-videos--"+$session);

			console.log( $session_section );

			$(".q-filter__items-list").find(".q-filter__items").removeClass("active-session");
			$item.parent().addClass("active-session");
			
			leftPos = $item.parent().position().left;
			newWidth = $item.parent().width();

			$underline.css({
				"left": leftPos,
				"width": newWidth
			});

			if( "all" === $session ){
				$(".q-grid__row-videos").removeClass("hidden");
			}
			else {
				$(".q-grid__row-videos").addClass("hidden");
				$session_section.removeClass("hidden");
			}

		});

		var derecalc = _.debounce( function(){
			$active_item = $(".active-session");
			console.log( $active_item.position().left );
			$underline.css({
				"left": $active_item.position().left,
				"width": $active_item.width()
			});
		} , 200);

		window.addEventListener("resize", derecalc );

		/**
		 * session filters dropdown
		 * show/hode dropdown options
		 * filter sesions
		 */

		var filterTopics, thisTopic, topicLabel, filterButton, topicSelector, totalBlocks, hiddenVideos;

		filterTopics = $(".q-filter__topic-list li a");
		filterButton = $(".js-q-filter-button");

		filterButton.on("click", function(){
			filterButton.parent().toggleClass("filter-open");
		});

		filterTopics.on("click", function(){

			thisTopic = $(this);
			topicLabel = thisTopic.text();
			topicSelector = thisTopic.data("topic");
			
			if( "All Topics" === topicLabel ){
				topicLabel = "Filter by topic";
			}

			filterButton.parent().removeClass("filter-open");
			filterTopics.removeClass("active-topic");
			thisTopic.addClass("active-topic");
			filterButton.text( topicLabel );

			if( "all" === topicSelector ){
				$(".q-videos__grid-block").removeClass("hidden");
			}
			else {
				$(".q-videos__grid-block").addClass("hidden");
				$(".q-videos__grid-block--"+topicSelector).removeClass("hidden");
			}

			$(".nothing-found").addClass("hidden");

			$(".q-videos__grid").each( function() {
				
				totalBlocks = $(this).find(".q-videos__grid-block");
				hiddenVideos = $(this).find(".q-videos__grid-block.hidden");
				
				$(this).find("#topic_txt").text(topicLabel);
				

				if( totalBlocks.length === hiddenVideos.length ) {
					$(this).find(".nothing-found").removeClass("hidden");
				}
			});

		});

		

	});

}(jQuery));